.plus {
  width: 32px;
  height: 32px;
}
.line {
  fill: none;
  stroke: #000000;
  stroke-width: 2px;
  stroke-miterlimit: 10;
}
